import React, { useRef }    from 'react';
import PropTypes            from 'prop-types';
import ReCAPTCHA            from 'react-google-recaptcha';
import { Bars }             from  'react-loader-spinner';
// import classNames       from 'classnames';

import Input                from '../../../../components/Input';
import Icons                from '../../../../../assets/svg/icons.js';
import BG                   from '../../../../../assets/images/subscribe.jpeg';

import useSubscribeBlock    from './useSubscribeBlock';
import { getErrorsText }    from '../../../../../utils/errors.js';

import styles               from './SubscribeBlock.styl';

function SubscribeBlock() {
    const captchaRef = useRef();

    const {
        handleChange,
        email,
        errors,
        handleSubscribe,
        isLoading
    } = useSubscribeBlock(captchaRef)

    return  (
        <section
            className={styles.SubscribeBlock}
            style = {{
                backgroundImage    : `url(${BG})`,
                backgroundPosition : 'center',
                backgroundSize     : 'cover'
            }}
        >
            <h2 className={styles.blockTitle}>
                <span className={styles.subscribeText}>
                    Subscribe
                </span> to our newsletter!
            </h2>
            <div className={styles.formBlock}>
                <Input
                    className   = {styles.emailInput}
                    placeholder = 'Email'
                    onChange    = {handleChange}
                    value       = {email}
                    error       = {getErrorsText(errors.email)}
                />
                <div
                    className = {styles.applyButton}
                    onClick   = {handleSubscribe}
                >
                    {isLoading
                        ? (
                            <Bars
                                height  = "20"
                                width   = "20"
                                color   = "#FFFFFF"
                                visible = {true}
                            />
                        )
                        : <Icons.SubscribeArrow />
                    }
                </div>
            </div>
            <ReCAPTCHA
                ref     = {captchaRef}
                size    = 'invisible'
                sitekey = '6LcKgNMiAAAAAMNYtke87BhLUPtUMB91y3jqg3Q7'
            />
        </section>
    );
}

SubscribeBlock.propTypes = {
    className : PropTypes.string
};

SubscribeBlock.defaultProps = {
    className : ''
};

export default SubscribeBlock;
